interface Props {
  small?: boolean;
  white?: boolean;
  clicable?: boolean;
}
const SvgLike: React.FC<Props> = ({ small, white, clicable }) => {
  return (
    <svg
      style={{
        transform: small ? "scale(0.67)" : "",
        cursor: clicable ? "pointer" : "default",
        color: white ? "var(--on-accent)" : undefined,
      }}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M9.12891 1.53806C9.04076 1.54068 8.95446 1.56399 8.87698 1.6061C8.7995 1.64821 8.73301 1.70795 8.68286 1.78049C8.68286 1.78049 8.09165 2.63824 7.37695 3.61228C6.66225 4.58631 5.79166 5.69994 5.37817 6.09079C4.59535 6.83097 4.0415 7.83804 4.0415 8.978V11.4375C4.0415 13.8126 5.9789 15.75 8.354 15.75H11.8564C13.2696 15.75 14.4702 14.6902 14.647 13.2883L14.8425 11.8901L15.1575 9.64011L15.2864 8.72312C15.4588 7.49239 14.4861 6.37497 13.2437 6.37497H10.0671C10.3268 5.73203 10.5176 5.14993 10.6509 4.49485C10.6511 4.49485 10.6514 4.49485 10.6516 4.49485C10.7296 4.11108 10.7952 3.80999 10.7952 3.48996C10.7952 2.71881 10.4014 2.16512 10.0195 1.88816C9.63766 1.61119 9.24097 1.54538 9.24097 1.54538C9.20395 1.53921 9.16641 1.53676 9.12891 1.53806ZM9.34351 2.79196C9.3515 2.79739 9.35079 2.79342 9.35889 2.79929C9.52041 2.91645 9.67017 3.05736 9.67017 3.48996C9.67017 3.63043 9.62587 3.89024 9.54858 4.27072C9.41046 4.9498 9.25369 5.47895 8.96338 6.15671C8.96338 6.15696 8.96338 6.1572 8.96338 6.15744C8.84149 6.44293 8.8536 6.76524 9.00293 7.03196C9.15226 7.29865 9.47093 7.49997 9.80713 7.49997H13.2437C13.8229 7.49997 14.252 7.99334 14.1716 8.56711L14.0435 9.48484L13.7285 11.7348L13.5322 13.1382C13.5317 13.1411 13.5312 13.144 13.5308 13.1469C13.4244 13.9962 12.712 14.625 11.8564 14.625H8.354C6.58686 14.625 5.1665 13.2046 5.1665 11.4375V8.978C5.1665 8.20246 5.54321 7.48275 6.15088 6.90818C6.73752 6.35365 7.55774 5.26742 8.28369 4.27805C8.86405 3.4871 9.16653 3.04664 9.34351 2.79196Z"
          className={`${white ? "fill-current" : "fill-primary"}`}
        />
      </g>
    </svg>
  );
};

export default SvgLike;
